import styled from "styled-components";

import { MaxWidthContainer } from "src/utils/css-mixins/css-mixins";

export const Container = styled(MaxWidthContainer)`
  padding-top: 60px;
`;
